import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { getWorkshopLeads, resendWorkshopLead, liveGet, livePost } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
const fonteLabel = (f) => (!f || f === "landing" ? "landing" : f.includes("utm") ? "ads" : f.slice(0, 18));

export function LeadsList({ live }) {
  const [leads, setLeads] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    if (!live) return;
    (live.live ? liveGet("workshop/leads") : getWorkshopLeads()).then(setLeads).catch(() => setLeads([]));
  }, [live]);

  const resend = async (id) => {
    setBusy(id);
    try {
      const upd = live?.live ? await livePost(`workshop/leads/${id}/resend`) : await resendWorkshopLead(id);
      setLeads((ls) => ls.map((l) => (l.id === id ? upd : l)));
      upd.forwarded ? toast.success("Inviato a GHL") : toast.error("GHL non ha risposto: riprova tra poco");
    } catch { toast.error("Errore nel reinvio"); }
    setBusy(null);
  };

  const reali = leads.filter((l) => !(l.email || "").toLowerCase().includes("test"));
  const ok = reali.filter((l) => l.forwarded).length;

  return (
    <div className="space-y-2" data-testid="strategy-leads">
      <div className="flex items-center justify-between">
        <p className="text-xs uppercase tracking-wide text-neutral-500">Iscritti dalla landing · {reali.length}</p>
        <p className="text-xs" data-testid="strategy-leads-ghl">
          <span style={{ color: ok === reali.length ? "#16A34A" : "#D92D20" }}>{ok}/{reali.length}</span>
          <span className="text-neutral-500"> arrivati a GHL</span>
        </p>
      </div>
      {reali.length === 0 ? (
        <p className="text-sm text-neutral-500" data-testid="strategy-leads-empty">Nessun iscritto reale ancora.</p>
      ) : (
        <ul className="divide-y divide-[#1a1a1a] max-h-72 overflow-y-auto" data-testid="strategy-leads-list">
          {reali.map((l) => (
            <li key={l.id} className="py-2 flex items-center gap-3 text-sm" data-testid={`lead-row-${l.id}`}>
              <span className="text-neutral-500 text-xs w-24 shrink-0">{fmt(l.created_at)}</span>
              <span className="text-neutral-200 truncate flex-1">{l.nome}</span>
              <span className="text-xs text-neutral-400 w-14 shrink-0" data-testid={`lead-eta-${l.id}`}>{l.eta || "—"}</span>
              <span className="text-[0.65rem] uppercase text-neutral-500 w-14 shrink-0">{fonteLabel(l.fonte)}</span>
              {l.forwarded ? (
                <CheckCircle2 size={16} className="shrink-0" style={{ color: "#16A34A" }} data-testid={`lead-ghl-ok-${l.id}`} />
              ) : (
                <button onClick={() => resend(l.id)} disabled={busy === l.id} className="flex items-center gap-1 text-xs shrink-0" style={{ color: "#D92D20" }} data-testid={`lead-resend-${l.id}`}>
                  <XCircle size={16} /> <RefreshCw size={12} className={busy === l.id ? "animate-spin" : ""} /> reinvia
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
